import { Box, Button, Tooltip } from '@mui/material';
import { GridCellProps } from '@progress/kendo-react-grid';
import { Activity } from 'src/types/activity';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import NoteIcon from '@mui/icons-material/Note';
import HandshakeIcon from '@mui/icons-material/Handshake';
import PushPinIcon from '@mui/icons-material/PushPin';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import CallMadeIcon from '@mui/icons-material/CallMade';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import useAuth from 'src/hooks/useAuth';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';

interface Props extends GridCellProps {
  dataItem: Activity;
  toggleTaskComplete?: (e: Activity) => void;
}

const ActivityTypeCell = (props: Props) => {
  let dataItem = props.dataItem as Activity;
  let icon = <CheckBoxOutlineBlankIcon />;
  const { user } = useAuth();

  switch (dataItem.activityType) {
    case 'Task':
      icon = <CheckBoxOutlineBlankIcon />;
      break;
    case 'Site Visit':
      icon = <HandshakeIcon />;
      break;
    case 'Note':
      icon = <NoteIcon />;
      break;
    case 'Meeting':
      icon = <HandshakeIcon />;
      break;
    case 'Call':
      icon = <PhoneIcon />;
      break;
    case 'Communication':
      icon = <EmailIcon />;
      break;
    default:
      icon = <CheckBoxOutlineBlankIcon />;
  }

  if (dataItem.activityType === 'Task' && dataItem.isComplete) {
    icon = <CheckBoxOutlinedIcon className={dataItem.isComplete && 'is-active'} />;
  }
  if (dataItem.activityType === 'Task' && !dataItem.isComplete) {
    icon = <CheckBoxOutlineBlankIcon />;
  }

  return (
    <td className="activity-grid__type-cell" data-grid-col-index={dataItem.activityId}>
      {dataItem?.isPinned && (
        <Box className="activity__pin">
          <PushPinIcon />
        </Box>
      )}

      {dataItem?.createdByCompanyUserId !== user.id && dataItem?.assignedTo === user.id && (
        <Box className="activity__pin pin--assigned">
          <Tooltip title="Assigned by another">
            <AssignmentIndIcon />
          </Tooltip>
        </Box>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {dataItem.activityType === 'Task' ? (
            <Button onClick={() => props.toggleTaskComplete(dataItem)}>
              {icon}
              <div className="activity-grid__type-cell__txt">{dataItem.activityType}</div>
            </Button>
          ) : (
            <>
              <div className="icon-container">
                {dataItem.activityType === 'Call' && (
                  <>
                    {dataItem.callDirection === 'Outbound' ? (
                      <CallMadeIcon fontSize="small" className="call-direction-icon" />
                    ) : (
                      <CallReceivedIcon fontSize="small" className="call-direction-icon" />
                    )}
                  </>
                )}
                {icon}
              </div>
              {dataItem.activityType === 'Communication' ? (
                <div className="activity-grid__type-cell__txt">Comm.</div>
              ) : (
                <div className="activity-grid__type-cell__txt">{dataItem.activityType}</div>
              )}
            </>
          )}
        </Box>
      </Box>
    </td>
  );
};

export default ActivityTypeCell;
